import { AuthService } from '@/services/auth.service';
import { KeychainHandler } from '@/plugins/keychain/plugin';

let _inFlight = null;

// Teto pro relogin: se a chamada nativa (prompt biométrico / makeLogin) travar
// (bug do plugin, rede pendurada), não deixa o overlay full-screen preso pra
// sempre — rejeita e o interceptor cai no clearToLogin.
const RELOGIN_TIMEOUT_MS = 30000;

// require lazy do store: import estático aqui entra na cadeia de init do
// base.service (TDZ "Cannot access 'BaseService' before initialization").
function setReloginPending (value) {
  try { require('@/store').default.commit('dom/SET_RELOGIN_PENDING', value); } catch {}
}

// Single-flight do relogin silencioso com as credenciais salvas no keychain
// (app nativo). N requests em 401 concorrente compartilham UM relogin, em vez
// de disparar N makeLogin / N prompts biométricos / N keep-alive. Retorna o
// access token novo, ou null se não houver credencial salva. Lança se o
// makeLogin falhar (rede/credencial inválida) ou estourar o timeout — o caller
// trata igual a hoje.
export function reloginWithStoredCredentials () {
  if (_inFlight == null) {
    setReloginPending(true);
    _inFlight = (async () => {
      // SEM timeout no prompt biométrico: o usuário pode levar tempo pra pôr o
      // dedo / encarar a câmera. Antes um teto de 30s aqui jogava quem demorava
      // pro login (e, se respondesse depois, o makeLogin setava tokens mas a UI
      // ficava presa no login). O prompt nativo se resolve/cancela sozinho.
      const credentials = await KeychainHandler.getCredentials();
      if (!credentials) return null;
      // O timeout cobre só o makeLogin (chamada de rede), que pode pendurar num
      // black hole de conexão — aí sim cai no fallback de login.
      let timer;
      try {
        await Promise.race([
          AuthService.makeLogin(credentials),
          new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('makeLogin timeout')), RELOGIN_TIMEOUT_MS); })
        ]);
      } finally {
        clearTimeout(timer);
      }
      return AuthService.getAccessToken();
    })().finally(() => {
      setReloginPending(false);
      _inFlight = null;
    });
  }
  return _inFlight;
}
